import {
  type ApiClient,
  type TokenStore,
  createApiClient,
  createStorageTokenStore,
} from '@dorixona/api'
import { env } from '../config/env'

export const TOKEN_STORAGE_KEY = 'dorixona.admin.tokens'

/** Staff tokens. They do not work on customer endpoints and vice versa. */
export function createAdminTokenStore(storage: Storage = localStorage): TokenStore {
  return createStorageTokenStore(TOKEN_STORAGE_KEY, storage)
}

export interface CreateAdminApiOptions {
  baseUrl?: string
  tokenStore?: TokenStore
  onAuthLost?: () => void
}

export function createAdminApi(options: CreateAdminApiOptions = {}): ApiClient {
  return createApiClient({
    baseUrl: options.baseUrl ?? env.apiBaseUrl,
    tokenStore: options.tokenStore ?? createAdminTokenStore(),
    refreshPath: '/admin/auth/refresh',
    onAuthLost: options.onAuthLost,
  })
}

/** Единственный клиент админки и хранилище её токенов. */
export const tokenStore = createAdminTokenStore()
export const api = createAdminApi({ tokenStore })
